import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellContext } from '@tanstack/react-table';
import { DeviceDashboardTableData } from '@/types/operational-ui.types';

export const DeviceDashboardStatusCell = (info: CellContext<DeviceDashboardTableData, any>) => {
  const { t } = useTranslation();
  const status = info.getValue();

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Active':
        return 'bg-green-100 text-green-800';
      case 'Inactive':
        return 'bg-red-100 text-red-800';
      case 'Maintenance':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <span
      className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(
        status
      )}`}
    >
      {t(`pages.operations.devices.status.${status.toLowerCase()}`)}
    </span>
  );
};
